import React from 'react'

const YouTubeIcon = () => (
    <svg
        version="1.1"
        height="30px"
        width="30px"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 30 30"
    >
        <circle fill="#FF0000" cx="14.9" cy="14.9" r="14.9" />
        <path
            fill="#FFFFFF"
            d="M17.4,19.5c0-0.1,0-0.2-0.1-0.4c-0.1-0.1-0.2-0.2-0.4-0.2c-0.2,0-0.3,0.1-0.5,0.2c0,0-0.1,0.1-0.1,0.1v3.9l0,0
			c0.1,0.1,0.2,0.2,0.4,0.2c0.2,0.1,0.4,0,0.5-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2C17.4,21.7,17.4,20.5,17.4,19.5L17.4,19.5z
			M17.4,19.5c0-0.1,0-0.2-0.1-0.4c-0.1-0.1-0.2-0.2-0.4-0.2c-0.2,0-0.3,0.1-0.5,0.2c0,0-0.1,0.1-0.1,0.1v3.9l0,0
			c0.1,0.1,0.2,0.2,0.4,0.2c0.2,0.1,0.4,0,0.5-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2C17.4,21.7,17.4,20.5,17.4,19.5L17.4,19.5z
			M21.7,13.7c-4.5-0.1-9.1-0.1-13.6,0c-1.6,0-2.8,1.3-2.8,2.9v7.1c0,1.6,1.3,2.9,2.8,2.9c4.5,0.1,9.1,0.1,13.6,0
			c1.6,0,2.8-1.3,2.8-2.9v-7.1C24.6,15,23.3,13.7,21.7,13.7L21.7,13.7z M9.5,24.3H8.1v-7.4H6.8v-1.2h4v1.2H9.5V24.3z M14.1,21.2v3.1
			H13v-0.7l-0.1,0.1c-0.2,0.3-0.5,0.5-0.9,0.6c-0.2,0-0.4,0-0.5,0c-0.2,0-0.4-0.2-0.5-0.4c-0.1-0.2-0.1-0.4-0.1-0.7c0-0.8,0-5.3,0-5.4
			H12c0,0,0,3.2,0,4.8c0,0.1,0,0.2,0,0.3c0,0.2,0.1,0.3,0.3,0.3c0,0,0.1,0,0.1,0c0.2-0.1,0.4-0.2,0.6-0.4c0,0,0-0.1,0-0.1v-4.7h1.2
			L14.1,21.2z M18.5,23.7c-0.1,0.4-0.5,0.7-1,0.7c-0.4,0-0.7-0.2-1-0.5l-0.1-0.1v0.5h-1.1v-8.6h1.2v2.8c0-0.1,0.1-0.1,0.1-0.2
			c0.2-0.2,0.4-0.4,0.7-0.4c0.5-0.1,1,0.1,1.2,0.5c0.1,0.3,0.2,0.7,0.2,1c0,1.2,0,2.4,0,3.6C18.6,23.3,18.6,23.5,18.5,23.7L18.5,23.7z
			M22.8,23.4c-0.2,0.6-0.7,0.9-1.2,1c-0.4,0.1-0.8,0-1.1-0.1c-0.5-0.2-0.8-0.6-0.9-1.1c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.9,0-1.9,0-2.8
			c0-0.5,0.2-1,0.5-1.3c0.4-0.4,0.9-0.6,1.4-0.6c0.2,0,0.3,0,0.5,0.1c0.5,0.2,0.9,0.6,1,1.1c0,0.2,0.1,0.4,0.1,0.6c0,0.5,0,1.6,0,1.6
			h-2.3v1.6c-0.1,0.3,0.1,0.6,0.4,0.6s0.6-0.1,0.6-0.4c0-0.1,0-0.2,0-0.3V22H23C23,22.5,23,22.9,22.8,23.4L22.8,23.4z M21.8,19.4
			c0.1-0.3-0.1-0.6-0.4-0.6s-0.6,0.1-0.6,0.4c0,0.1,0,0.2,0,0.3v0.9h1V19.4z M17.4,19.1c-0.1-0.1-0.2-0.2-0.4-0.2
			c-0.2,0-0.3,0.1-0.5,0.2c0,0-0.1,0.1-0.1,0.1v3.9l0,0c0.1,0.1,0.2,0.2,0.4,0.2c0.2,0.1,0.4,0,0.5-0.2c0,0,0-0.1,0-0.1
			c0-0.1,0-0.1,0-0.2c0-1.1,0-2.3,0-3.4C17.4,19.3,17.3,19.2,17.4,19.1L17.4,19.1z"
        />
        <path
            fill="#FFFFFF"
            d="M20.3,5.5v6.4h-1.2v-0.7c-0.1,0.1-0.2,0.2-0.4,0.4c-0.2,0.2-0.5,0.4-0.8,0.4c-0.4,0.2-0.8,0-1-0.4
			c0,0,0-0.1,0-0.1c0-0.2,0-0.3,0-0.5V5.5h1.2v4.9c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.3,0.3,0.3c0,0,0.1,0,0.1,0c0.2-0.1,0.4-0.2,0.6-0.4
			c0,0,0-0.1,0-0.1V5.5H20.3z"
        />
        <path
            fill="#FFFFFF"
            d="M10.5,6.6L9.7,3.2H8.4l1.5,5c0,0.1,0,0.1,0,0.2v3.5h1.2V8.4c0-0.1,0-0.1,0-0.2l1.5-5h-1.3L10.5,6.6L10.5,6.6z"
        />
        <path
            fill="#FFFFFF"
            d="M14.3,5.3c-0.9,0-1.7,0.7-1.7,1.7v3.3c0,0.9,0.8,1.7,1.7,1.7c0.9,0,1.7-0.8,1.7-1.7V7C16,6.1,15.2,5.3,14.3,5.3
			L14.3,5.3z M14.8,10.4c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5V7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V10.4z"
        />
    </svg>
)

export default YouTubeIcon
